// extracted by mini-css-extract-plugin
export var circle = "styles-module--circle--82dc7";
export var circle1 = "styles-module--circle1--c34c8";
export var circle2 = "styles-module--circle2--cea5f";
export var circle3 = "styles-module--circle3--bdd38";